import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import moment from 'moment';


export class SelectCustomerJob extends Component {

  state = {
    selectedJob : "X"
  }

  handleSelect = async () => {
    this.props.onSelect(this.props.jobs[this.state.selectedJob])
  };

// In this modal, we'll display the list of jobs for the selected vehicle we have already done work for 
// the user can pick one and it will populate the list or cancel and add new ones
  
    render(){
      console.log("SelectCustomerJob : Jobs we have :", this.props.jobs);
//      //console.log("selectCustomerJob : step : ", this.props.step)

      let displayJobs = this.props.jobs;
      for (let index = 0; index < displayJobs.length; index++) {
        let conv = moment(displayJobs[index].created_date).format("MMM D, YYYY");
        displayJobs[index].createDateString = conv;;
      }
      
    const columns = [{
      dataField: 'createDateString',
      text:"When"},{
      dataField: 'Service_Requested',
        text:"Service"},{
        dataField: 'vehicle_description',
        text:"Vehicle"},{
        dataField: `Request_Total`,
        text:"Amount",
        formatter: (cell, row) => {
          // Calculate final amount: original total - discount
          const requestTotal = parseFloat(row.Request_Total || 0);
          const requestDiscount = parseFloat(row.Request_Discount || 0);
          const finalAmount = requestTotal - requestDiscount;
          return "$" + finalAmount.toFixed(2);
        }
        }
        ];

      const selectRow = {
        mode: 'radio',
        clickToSelect: true,
        bgColor : 'grey',      
        onSelect: (e, row, rowIndex) => {
          this.setState({selectedJob : rowIndex});
//          //console.log ("Row selected : ", this.state.selectedJob);
          //            this.props.onSelect(row);
        }
      };

      const rowEvents = {
        onClick: (e, row, rowIndex) => {
          this.setState({selectedJob : rowIndex});
 //         //console.log ("Row selected : ", this.state.selectedJob);
 //            this.props.onSelect(row);
        }};

        // Get the customer name from the first job record
        const customerName = this.props.jobs && this.props.jobs.length > 0 
          ? this.props.jobs[0].requestor_name 
          : "Customer";

        let message = `Jobs completed for ${customerName}`
        if (this.props.mode === "select") {
          message = `Select one of ${customerName}'s previous jobs or Add a new one`
        }
        if (this.props.step === 99) {
          message = "Select the job to load the services";
        }
        //console.log("selectCustomerJob : selectedRow :", this.state.selectedJob);

      return(
            <Modal
            show={this.props.showJobList}
            onHide={this.props.onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
                {message}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="container">
              <BootstrapTable
                  keyField='Request_id'
                  data={displayJobs}
                  columns={columns}
                  selectRow={selectRow}
                  rowEvents={rowEvents} />
              </div>
            {this.props.mode === "select" && this.state.selectedJob !== "X" && <button type="button" onClick={() => this.handleSelect()} className="btn btn-success m-2 buttons">Select</button>}
            {this.props.mode === "select" && this.props.step !== 99 && <button type="button" onClick={() => this.props.onHide()} className="btn btn-danger m-2 buttons">Enter New One</button>}
            {this.props.mode === "view" && <button type="button" onClick={() => this.props.onHide()} className="btn btn-danger m-2 buttons">CANCEL</button>}

            </Modal.Body>
          </Modal>
        );
    };
};